module.exports = __webpack_public_path__ + "img/art_home_time.89482c4b.png";